import {useState} from 'react'
import {PrivacyPolicy} from './core/_models'
import {useMutation} from 'react-query'
import {acceptPrivacyPolicy} from './core/_requests'
import {useAuth} from '../../../../app/modules/auth'

type Props = {
  privacyPolicy: PrivacyPolicy
}

export function PrivacyPolicyModalContent({privacyPolicy}: Props) {
  const [accept, setAccept] = useState(false)
  const {setCurrentUser} = useAuth()

  const {mutateAsync: privacyAgreementFn} = useMutation(() => acceptPrivacyPolicy())

  function handlePrivacyAgreement(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    privacyAgreementFn()
    setCurrentUser((prev) => (prev ? {...prev, privacy_agreement: true} : prev))
  }

  return (
    <>
      <div className='modal-header border-0' style={{maxWidth: '100%'}}>
        <div className='col-md-11'>
          <div className='d-flex'>
            <h2 className='fs-bold fs-1'>Política de Privacidade</h2>
          </div>
          {!!privacyPolicy.version && (
            <span className='d-block ms-1 mt-1'>Versão: {privacyPolicy.version}</span>
          )}
        </div>
      </div>
      <div className='modal-body' style={{maxWidth: '100%'}}>
        <div className='tab-content' style={{maxWidth: '100%'}}>
          <div
            className='tab-pane fade active show'
            style={{maxWidth: '100%'}}
            id='kt_tab_pane_1'
            role='tabpanel'
            dangerouslySetInnerHTML={{__html: privacyPolicy.content}}
          ></div>
        </div>
        <div className='d-flex flex-column align-items-center justify-content-center gap-4 mt-8 mb-4'>
          <div className='position-relative'>
            <label
              className='form-check form-switch form-check-custom form-check-solid'
              role='button'
            >
              <input
                className={`form-check-input h-20px w-30px me-2 `}
                type='checkbox'
                role='button'
                onChange={(e) => setAccept(e.target.checked)}
                checked={accept}
              />
              Declaro que li e concordo com os termos acima
            </label>
          </div>
          <button
            className='btn btn-primary dash-toolbar-btn-primary btn-sm w-fit-content py-2 px-10'
            onClick={handlePrivacyAgreement}
            disabled={!accept}
          >
            Aceito os termos de uso
          </button>{' '}
        </div>
      </div>
    </>
  )
}
